import * as types from '../mutations-types'
import {
  getCurrentConditionReport,
  getPointData,
  getSpeedVehicleReport,
  getSpeedTimeReport,
  getTimeReport,
  getPointReport,
  getLastEventReport,
  getReportMissionFailTime,
  getReportMissionFailVehicle,
  getReportMovementAlarmsTime,
  getReportMovementAlarmsVehicle,
  getReportParkingAlarmsTime,
  getReportParkingAlarmsVehicle,
  getLogHistoryReport,
  getGeofenceInAlarmReportVehicle,
  getGeofenceInAlarmReportTime
} from '../../utils/api'

import {createActionHelpers} from 'vuex-loading'
const {startLoading} = createActionHelpers({
  moduleName: 'loading'
})

// STATES
const state = {
  urlReportGCCR: '',
  reportReadyGCCR: false,
  reportReadyGLER: false,
  urlReportGLER: '',
  showResult: false,
  viewPointData: [],
  reportReadyGSVR: false,
  urlReportGSVR: '',
  reportReadyGSTR: false,
  urlReportGSTR: '',
  reportReadyGGOAT: false,
  urlReportGGOAT: '',
  reportReadyGGOAV: false,
  urlReportGGOAV: '',
  urlReportGRMAT: '',
  reportReadyGRMAT: false,
  urlReportGRMAV: '',
  reportReadyGRMAV: false,
  reportReadyPAT: false,
  urlReportPAT: '',
  reportReadyPAV: false,
  urlReportPAV: '',
  reportReadyLH: false,
  urlReportLH: '',
  reportReadyGGIARV: false,
  urlReportGGIARV: '',
  reportReadyGGIART: false,
  urlReportGGIART: ''
}

// GETTERS
const getters = {
  urlReportGCCR: state => state.urlReportGCCR,
  reportReadyGCCR: state => state.reportReadyGCCR,
  reportReadyGLER: state => state.reportReadyGLER,
  urlReportGLER: state => state.urlReportGLER,
  showResult: state => state.showResult,
  viewPointData: state => state.viewPointData,
  reportReadyGSVR: state => state.reportReadyGSVR,
  urlReportGSVR: state => state.urlReportGSVR,
  reportReadyGSTR: state => state.reportReadyGSTR,
  urlReportGSTR: state => state.urlReportGSTR,
  reportReadyGGOAT: state => state.reportReadyGGOAT,
  urlReportGGOAT: state => state.urlReportGGOAT,
  reportReadyGGOAV: state => state.reportReadyGGOAV,
  urlReportGGOAV: state => state.urlReportGGOAV,
  urlReportGRMAT: state => state.urlReportGRMAT,
  reportReadyGRMAT: state => state.reportReadyGRMAT,
  urlReportGRMAV: state => state.urlReportGRMAV,
  reportReadyGRMAV: state => state.reportReadyGRMAV,
  reportReadyPAT: state => state.reportReadyPAT,
  urlReportPAT: state => state.urlReportPAT,
  reportReadyPAV: state => state.reportReadyPAV,
  urlReportPAV: state => state.urlReportPAV,
  reportReadyLH: state => state.reportReadyLH,
  urlReportLH: state => state.urlReportLH,
  reportReadyGGIARV: state => state.reportReadyGGIARV,
  urlReportGGIARV: state => state.urlReportGGIARV,
  reportReadyGGIART: state => state.reportReadyGGIART,
  urlReportGGIART: state => state.urlReportGGIART
}

// ACTIONS
const actions = {
  toggleBtnGCCR({commit}, value) {
    commit(types.SET_DOWNLOAD_GCCR, value)
  },
  async getCurrentConditionReport({commit, dispatch}) {
    await startLoading(dispatch, 'fetchCurrentConditionReport', () => {
      return getCurrentConditionReport()
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_GCCR, url)
          commit(types.SET_DOWNLOAD_GCCR, true)
        }
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('GCCR', error.response)
          if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('GCCR', error)
      })
  },
  toggleBtnGLER({commit}, value) {
    commit(types.SET_DOWNLOAD_GLER, value)
  },
  async getLastEventReport({commit, dispatch}, payload) {
    await startLoading(dispatch, 'fetchLastEventReport', () => {
      return getLastEventReport(payload)
    })
      .then(response => {
        // console.log('getLastEventReport', response)
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_GLER, url)
          commit(types.SET_DOWNLOAD_GLER, true)
        }
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('GLER', error.response)
          if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('GLER', error)
      })
  },
  showResultAction({commit}, value) {
    commit(types.SET_SHOW_RESULT, value)
    commit(types.SET_VIEW_POINT_DATA, [])
  },
  async getPointData({commit, dispatch}, payload) {
    await startLoading(dispatch, 'fetchingPointData', () => {
      return getPointData(payload)
    })
      .then(response => {
        // console.log('GET POINT DATA', response)
        const data = response.data
        // console.log('DATA GPD', data)
        commit(types.SET_VIEW_POINT_DATA, data)
        commit(types.SET_SHOW_RESULT, true)
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('GPD', error.response)
          if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('GPD', error)
      })
  },
  toggleBtnGSVR({commit}, value) {
    commit(types.SET_DOWNLOAD_GSVR, value)
  },
  async getSpeedVehicleReport({dispatch, commit}, payload) {
    await startLoading(dispatch, 'generatingSpeedVehicleReport', () => {
      return getSpeedVehicleReport(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          // console.log('URL: ', url)
          commit(types.SET_URL_GSVR, url)
          commit(types.SET_DOWNLOAD_GSVR, true)
        }
      })
  },
  toggleBtnGSTR({commit}, value) {
    commit(types.SET_DOWNLOAD_GSTR, value)
  },
  async getSpeedTimeReport({dispatch, commit}, payload) {
    await startLoading(dispatch, 'generatingSpeedTimeReport', () => {
      return getSpeedTimeReport(payload)
    })
      .then(response => {
        // console.log('RESPONSE: ', response)
        if (response.status === 200) {
          const url = response.data.url
          // console.log('URL: ', url)
          commit(types.SET_URL_GSTR, url)
          commit(types.SET_DOWNLOAD_GSTR, true)
        }
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('GSTR', error.response)
          if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('GSTR', error)
      })
  },
  getTimeReport({commit, dispatch}, {id, date1 = null, time1Date1 = null, time2Date1 = null, date2 = null, time1Date2 = null}) {
    return new Promise(async(resolve, reject) => {
      const response = await startLoading(dispatch, 'generatingTimeReport', () => {
        return getTimeReport({id, date1, time1Date1, time2Date1, date2, time1Date2})
      })
      if (response.status === 200) {
        // console.log('200')
        resolve('OK')
      } else if (response.status === 400) {
        console.warn('400')
        resolve('BAD FORMAT')
      } else if (response.status === 500) {
        // alert('ERROR!\n\nSe ha presentado un error al tratar de generar el reporte. Por favor intentelo de nuevo.\n\nSí el error persiste por favor contactar al administrador del sistema.')
        console.error('500')
        resolve('SERVER ERROR')
      } else {
        reject(new Error('ERROR'))
      }
    })
    // await startLoading(dispatch, 'generatingTimeReport', () => {
    //   return getTimeReport({id, date1, time1Date1, time2Date1, date2, time1Date2})
    // })
    //   .then(response => {
    //     console.log(response)
    //     if (response.status === 200) {
    //       console.log('200')
    //       resolve(response)
    //     }
    //     // const url = window.URL.createObjectURL(new Blob([response.data]))
    //     // const link = document.createElement('a')
    //     // link.href = url
    //     // const contentDisposition = response.request.getResponseHeader('content-disposition')
    //     // let fileName = 'reportUnamed.xlsx'
    //     // const startIndex = contentDisposition.indexOf('filename=') + 9
    //     // const endIndex = contentDisposition.length
    //     // fileName = contentDisposition.substring(startIndex, endIndex)
    //     // // console.log('filename: ' + fileName)
    //     // link.setAttribute('download', fileName)
    //     // document.body.appendChild(link)
    //     // link.click()
    //     // link.parentNode.removeChild(link)
    //   })
    //   .catch(error => {
    //     if (error.hasOwnProperty('response')) {
    //       console.log('GTR', error.response)
    //       // if (error.response.status === 401) dispatch('auth/logout')
    //     } else console.log('GTR', error)
    //   })
  },
  async getPointReport({commit, dispatch}, payload) {
    await startLoading(dispatch, 'generatingPointReport', () => {
      return getPointReport(payload)
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const contentDisposition = response.request.getResponseHeader('content-disposition')
        let fileName = 'reportUnamed.xlsx'
        const startIndex = contentDisposition.indexOf('filename=') + 9
        const endIndex = contentDisposition.length
        fileName = contentDisposition.substring(startIndex, endIndex)
        // console.log('filename: ' + fileName)
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('GPR', error.response)
          if (error.response.status === 500) {
            alert('ERROR!\n\nSe ha presentado un error al tratar de generar el reporte. Por favor intentelo de nuevo.\n\nSí el error persiste por favor contactar al administrador del sistema.')
          } else if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('GPR', error)
      })
  },
  async getReportMissionFailTime({commit, dispatch}, payload) {
    await startLoading(dispatch, 'generatingReportMissionFailTime', () => {
      return getReportMissionFailTime(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_GGOAT, url)
          commit(types.SET_DOWNLOAD_GGOAT, true)
        }
      })
      .catch(error => {
        console.error('ERROR GGOAT', error)
      })
  },
  toggleBtnGGOAT({commit}, value) {
    commit(types.SET_DOWNLOAD_GGOAT, value)
  },
  async getReportMissionFailVehicle({commit, dispatch}, payload) {
    await startLoading(dispatch, 'generatingReportMissionFailVehicle', () => {
      return getReportMissionFailVehicle(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_GGOAV, url)
          commit(types.SET_DOWNLOAD_GGOAV, true)
        }
      })
      .catch(error => {
        console.error('ERROR GGOAV', error)
      })
  },
  toggleBtnGGOAV({commit}, value) {
    commit(types.SET_DOWNLOAD_GGOAV, value)
  },
  async getReportMovementAlarmsTime({commit, dispatch}, payload) {
    await startLoading(dispatch, 'generatingReportMovementAlarmsTime', () => {
      return getReportMovementAlarmsTime(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_GRMAT, url)
          commit(types.SET_DOWNLOAD_GRMAT, true)
        }
      })
      .catch(error => {
        console.error('ERROR GRMAT', error)
      })
  },
  toggleBtnGRMAT({commit}, value) {
    commit(types.SET_DOWNLOAD_GRMAT, value)
  },
  async getReportMovementAlarmsVehicle({commit, dispatch}, payload) {
    await startLoading(dispatch, 'generatingReportMovementAlarmsVehicle', () => {
      return getReportMovementAlarmsVehicle(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_GRMAV, url)
          commit(types.SET_DOWNLOAD_GRMAV, true)
        }
      })
      .catch(error => {
        console.error('ERROR GRMAV', error)
      })
  },
  toggleBtnGRMAV({commit}, value) {
    commit(types.SET_DOWNLOAD_GRMAV, value)
  },
  async getReportParkingAlarmsTime({commit, dispatch}, payload) {
    await startLoading(dispatch, 'generatingReportParkingAlarmsTime', () => {
      return getReportParkingAlarmsTime(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_PAT, url)
          commit(types.SET_DOWNLOAD_PAT, true)
        }
      })
      .catch(error => {
        console.error('ERROR PAT', error)
      })
  },
  toggleBtnPAT({commit}, value) {
    commit(types.SET_DOWNLOAD_PAT, value)
  },
  async getReportParkingAlarmsVehicle({commit, dispatch}, payload) {
    await startLoading(dispatch, 'generatingReportParkingAlarmsVehicle', () => {
      return getReportParkingAlarmsVehicle(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_PAV, url)
          commit(types.SET_DOWNLOAD_PAV, true)
        }
      })
      .catch(error => {
        console.error('ERROR PAV', error)
      })
  },
  toggleBtnPAV({commit}, value) {
    commit(types.SET_DOWNLOAD_PAV, value)
  },
  async getLogHistoryReport({commit, dispatch}, payload) {
    await startLoading(dispatch, 'generatingLogsHistoryReport', () => {
      return getLogHistoryReport(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_LHR, url)
          commit(types.SET_DOWNLOAD_LHR, true)
        }
      })
      .catch(error => {
        if (error.response.status === 422) {
          alert('ERROR\n\nSe presentó un error relacionado con el rango de fechas y horas solicitados.\n\nRecuerde que el rango máximo es de 24 horas, y debe estar dentro de una fecha válida.')
        }
        console.error('ERROR LHR', error)
      })
  },
  toggleBtnLHR({commit}, value) {
    commit(types.SET_DOWNLOAD_LHR, value)
  },
  async getGeofenceInAlarmReportVehicle({dispatch, commit}, payload) {
    await startLoading(dispatch, 'generatingGeofenceInAlarmVehicleReport', () => {
      return getGeofenceInAlarmReportVehicle(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_GGIARV, url)
          commit(types.SET_DOWNLOAD_GGIARV, true)
        }
      })
      .catch(error => {
        console.log('ERROR GGIARV', error)
      })
  },
  toggleBtnGGIARV({commit}, value) {
    commit(types.SET_DOWNLOAD_GGIARV, value)
  },
  async getGeofenceInAlarmReportTime({dispatch, commit}, payload) {
    await startLoading(dispatch, 'generatingGeofenceInAlarmTimeReport', () => {
      return getGeofenceInAlarmReportTime(payload)
    })
      .then(response => {
        if (response.status === 200) {
          const url = response.data.url
          commit(types.SET_URL_GGIART, url)
          commit(types.SET_DOWNLOAD_GGIART, true)
        }
      })
      .catch(error => {
        console.error('ERROR GGIART', error)
      })
  },
  toggleBtnGGIART({commit}, value) {
    commit(types.SET_DOWNLOAD_GGIART, value)
  }
}

// MUTATIONS
const mutations = {
  [types.SET_DOWNLOAD_GCCR](state, value) {
    state.reportReadyGCCR = value
  },
  [types.SET_URL_GCCR](state, value) {
    state.urlReportGCCR = value
  },
  [types.SET_DOWNLOAD_GLER](state, value) {
    state.reportReadyGLER = value
  },
  [types.SET_URL_GLER](state, value) {
    state.urlReportGLER = value
  },
  [types.SET_SHOW_RESULT](state, value) {
    state.showResult = value
  },
  [types.SET_VIEW_POINT_DATA](state, data) {
    state.viewPointData = data
  },
  [types.SET_URL_GSVR](state, value) {
    state.urlReportGSVR = value
  },
  [types.SET_DOWNLOAD_GSVR](state, value) {
    state.reportReadyGSVR = value
  },
  [types.SET_URL_GSTR](state, value) {
    state.urlReportGSTR = value
  },
  [types.SET_DOWNLOAD_GSTR](state, value) {
    state.reportReadyGSTR = value
  },
  [types.SET_DOWNLOAD_GGOAT](state, value) {
    state.reportReadyGGOAT = value
  },
  [types.SET_URL_GGOAT](state, value) {
    state.urlReportGGOAT = value
  },
  [types.SET_DOWNLOAD_GGOAV](state, value) {
    state.reportReadyGGOAV = value
  },
  [types.SET_URL_GGOAV](state, value) {
    state.urlReportGGOAV = value
  },
  [types.SET_URL_GRMAT](state, value) {
    state.urlReportGRMAT = value
  },
  [types.SET_DOWNLOAD_GRMAT](state, value) {
    state.reportReadyGRMAT = value
  },
  [types.SET_URL_GRMAV](state, value) {
    state.urlReportGRMAV = value
  },
  [types.SET_DOWNLOAD_GRMAV](state, value) {
    state.reportReadyGRMAV = value
  },
  [types.SET_URL_PAT](state, value) {
    state.urlReportPAT = value
  },
  [types.SET_DOWNLOAD_PAT](state, value) {
    state.reportReadyPAT = value
  },
  [types.SET_URL_PAV](state, value) {
    state.urlReportPAV = value
  },
  [types.SET_DOWNLOAD_PAV](state, value) {
    state.reportReadyPAV = value
  },
  [types.SET_DOWNLOAD_LHR](state, value) {
    state.reportReadyLH = value
  },
  [types.SET_URL_LHR](state, value) {
    state.urlReportLH = value
  },
  [types.SET_URL_GGIARV](state, value) {
    state.urlReportGGIARV = value
  },
  [types.SET_DOWNLOAD_GGIARV](state, value) {
    state.reportReadyGGIARV = value
  },
  [types.SET_URL_GGIART](state, value) {
    state.urlReportGGIART = value
  },
  [types.SET_DOWNLOAD_GGIART](state, value) {
    state.reportReadyGGIART = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reports.js